module.exports = __webpack_public_path__ + "img/9cd6aa7.jpg";